import type { SVGProps } from 'react';

const SvgUserTypePower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.98 5.23a.51.51 0 0 0-.4-.34l-2.5-.36-1.12-2.27c-.17-.34-.73-.34-.9 0l-1.12 2.27-2.5.36a.5.5 0 0 0-.4.34c-.06.18 0 .38.13.51l1.81 1.77-.43 2.49c-.03.19.05.38.2.49s.36.13.53.04l2.24-1.18 2.24 1.18c.07.04.15.06.23.06.1 0 .21-.03.29-.1.15-.11.23-.3.2-.49l-.43-2.49 1.81-1.77c.14-.13.19-.33.13-.51zm-7.84 9.4c.19-.27.37-.55.5-.86a.99.99 0 0 0-.53-1.31 1 1 0 0 0-1.31.53 2.501 2.501 0 0 1-4.6-1.96 2.5 2.5 0 0 1 3.28-1.32.995.995 0 0 0 1.31-.53.99.99 0 0 0-.53-1.31c-2.28-.97-4.93.09-5.9 2.38a4.5 4.5 0 0 0-.04 3.44c.14.34.33.65.54.95A6.45 6.45 0 0 0 3 20.01c0 .55.45 1 1 1s1-.45 1-1c0-1.71.96-3.24 2.47-4 .09.05.17.1.26.14.57.24 1.17.36 1.76.36.72 0 1.41-.18 2.04-.5 1.51.76 2.46 2.28 2.46 4 0 .55.45 1 1 1s1-.45 1-1c0-2.21-1.1-4.18-2.86-5.37z"
    />
  </svg>
);
export default SvgUserTypePower;
